export default {
    namespaced: true,
    state: {
        category: null,
        course: null,
        ecp: null,
        convention: null,
        program: null,
        rate: null,
        mp_tot: null,
        installments: null,
        installments_next: null,
        singles: null,

    },
    mutations: {
        'SET_CATEGORY' (state, category) {
            state.category = category
        },
        'SET_COURSE' (state, course) {
            state.course = course
        },
        'SET_ECP' (state, ecp) {
            state.ecp = ecp
        },
        'SET_CONVENTION' (state, convention) {
            state.convention = convention
        },
        'SET_PROGRAM' (state, program) {
            state.program = program
        },
        'SET_RATE' (state, rate) {
            state.rate = rate
        },
        'SET_IMPORT' (state, mp_tot) {
            state.mp_tot = mp_tot
        },
        'SET_INSTALLMENTS' (state, installments) {
            state.installments = installments
        },
        'SET_SINGLES' (state, singles) {
            state.singles = singles
        },
        'SET_INSTALLMENTS_NEXT' (state, installments_next) {
            state.installments_next = installments_next
        }
    },
    actions: {
        setCategory({ commit }, category) {
            commit('SET_CATEGORY', category)
        },
        setCourse({ commit }, course) {
            commit('SET_COURSE', course)
        },
        setEcp({ commit }, ecp) {
            commit('SET_ECP', ecp)
        },
        setConvention({ commit }, convention) {
            commit('SET_CONVENTION', convention)
        },
        setProgram({ commit }, program) {
            commit('SET_PROGRAM', program)
        },
        setRate({ commit}, rate) {
            commit('SET_RATE', rate)
        },
        setImport({ commit }, mp_tot) {
            commit('SET_IMPORT', mp_tot)
        },
        setInstallments({ commit }, installments) {
            commit('SET_INSTALLMENTS', installments)
        }, 
        setInstallmentsNext({ commit }, installments_next) {
            commit('SET_INSTALLMENTS_NEXT', installments_next)
        }, 
        setSingles({ commit }, singles) {
            commit('SET_SINGLES', singles)
        }
        
    },
    getters: {
        category: state => state.category,
        course: state => state.course,
        ecp: state => state.ecp,
        convention: state => state.convention,
        program: state => state.program,
        rate: state => state.rate,
        mp_tot: state => state.mp_tot,
        installments: state => state.installments,
        installments_next: state => state.installments_next,
        singles: state => state.singles
    }
}